module.exports = __webpack_public_path__ + "static/media/promo-banner.18ed88ac.jpg";